import { createColumnConfigHelper } from '@components/data-table-filter/core/filters';
import { Building2Icon, FolderTreeIcon, Globe2Icon, Layers3Icon, TargetIcon } from 'lucide-react';

export type IntelTechnologyFilterRow = {
  categoryIds: string[];
  companyIds: string[];
  domainIds: string[];
  subcategoryIds: string[];
  useIds: string[];
};

const dtf = createColumnConfigHelper<IntelTechnologyFilterRow>();

export const intelTechnologiesFilterColumnsConfig = [
  dtf
    .multiOption()
    .id('companyIds')
    .accessor((row) => row.companyIds)
    .displayName('Organization')
    .icon(Building2Icon)
    .options([])
    .build(),
  dtf
    .multiOption()
    .id('categoryIds')
    .accessor((row) => row.categoryIds)
    .displayName('Category')
    .icon(FolderTreeIcon)
    .options([])
    .build(),
  dtf
    .multiOption()
    .id('subcategoryIds')
    .accessor((row) => row.subcategoryIds)
    .displayName('Subcategory')
    .icon(Layers3Icon)
    .options([])
    .build(),
  dtf
    .multiOption()
    .id('domainIds')
    .accessor((row) => row.domainIds)
    .displayName('Domain')
    .icon(Globe2Icon)
    .options([])
    .build(),
  dtf
    .multiOption()
    .id('useIds')
    .accessor((row) => row.useIds)
    .displayName('Use')
    .icon(TargetIcon)
    .options([])
    .build(),
] as const;
